<template>
    <div class="filter-breadcrumbs">
        <span v-for="ad_type in selected_ad_types"
              :key="`ad_type_${ad_type.id}`"
              class="label label-success m-r-10">
            <i @click="removeFilter('ad_type', ad_type.id)" class="fa fa-times-circle m-r-5"></i>
            {{ ad_type.name }}
        </span>
        <span v-for="property_type in selected_property_types"
              :key="`property_type_${property_type.id}`"
              class="label label-success m-r-10">
            <i @click="removeFilter('property_type', property_type.id)" class="fa fa-times-circle m-r-5"></i>
            {{ property_type.name }}
        </span>
        <span v-for="d in selected_districts"
              :key="`district_${d}`"
              class="label label-success m-r-10">
            <i @click="removeFilter('district', d)" class="fa fa-times-circle m-r-5"></i>
            {{ d | truncate(25) }}
        </span>
        <span v-if="filter.gender.includes('M')" class="label label-success m-r-10"><i @click="removeFilter('gender', 'M')" class="fa fa-times-circle m-r-5"></i>Apenas para homens</span>
        <span v-if="filter.gender.includes('F')" class="label label-success m-r-10"><i @click="removeFilter('gender', 'F')" class="fa fa-times-circle m-r-5"></i>Apenas para mulheres</span>
        <span v-if="filter.gender.includes('MF')" class="label label-success m-r-10"><i @click="removeFilter('gender', 'MF')" class="fa fa-times-circle m-r-5"></i>Moradias Mistas</span>
        <span v-if="price_touched" class="label label-success m-r-10"><i @click="removeFilter('price_range')" class="fa fa-times-circle m-r-5"></i>R$ {{ filter.price_range[0] }} - R$ {{ filter.price_range[1] }}</span>
        <span v-for="bedroom in filter.bedrooms" v-bind:key="bedroom" class="label label-success m-r-10"><i @click="removeFilter('bedrooms', bedroom)" class="fa fa-times-circle m-r-5"></i>{{ bedroom }} {{ bedroom > 1 ? 'quartos' : 'quarto' }}</span>
        <span v-for="bathroom in filter.bathrooms" v-bind:key="bathroom" class="label label-success m-r-10"><i @click="removeFilter('bathrooms', bathroom)" class="fa fa-times-circle m-r-5"></i>{{ bathroom }} {{ bathroom > 1 ? 'banheiros' : 'banheiro' }}</span>
        <span v-for="(am, key) in selected_amenities" v-bind:key="key" class="label label-success m-r-10"><i @click="removeFilter('amenity', am.id)" class="fa fa-times-circle m-r-5"></i>{{ am.name | truncate(25) }}</span>
        <span v-for="(rule, key) in selected_rules" v-bind:key="key" class="label label-success m-r-10"><i @click="removeFilter('rule', rule.id)" class="fa fa-times-circle m-r-5"></i>{{ rule.name | truncate(25) }}</span>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        filter() {
            return this.$store.getters.getFilter;
        },
        ad_types() {
            return this.$store.getters.getAdTypes;
        },
        property_types() {
            return this.$store.getters.getPropertyTypes;
        },
        amenities() {
            return this.$store.getters.getAmenities;
        },
        rules() {
            return this.$store.getters.getRules;
        },
        price_touched: function () {
            return this.filter.price_range[0] != 0 || this.filter.price_range[1] != 15000;
        },
        selected_districts() {
            return this.$store.getters.getSelectedDistricts || [];
        },
        selected_amenities() {
            const amenities = this.filter.amenities.map(id => Number(id));
            return this.amenities.filter(obj => amenities.includes(obj.id));
        },
        selected_ad_types() {
            const ad_types = this.filter.ad_type.map(id => Number(id));
            return this.ad_types.filter(obj => ad_types.includes(obj.id));
        },
        selected_property_types() {
            const property_types = this.filter.property_type.map(id => Number(id));
            return this.property_types.filter(obj => property_types.includes(obj.id));
        },
        selected_rules() {
            const rules = this.filter.rules.map(id => Number(id));
            return this.rules.filter(obj => rules.includes(obj.id));
        },
    },
    filters: {
        truncate: function(string, value) {
            if (string.length > value)
                return string.substring(0 , value) + '...';
            else
                return string;
        }
    },
    methods: {
        removeFilter(name, value = null) {
            switch (name) {
                case 'gender':
                    this.$store.commit('removeFromFilter', { gender: value });
                    break;
                case 'ad_type':
                    this.$store.commit('removeFromFilter', { ad_type: value });
                    break;
                case 'property_type':
                    this.$store.commit('removeFromFilter', { property_type: value });
                    break;
                case 'price_range':
                    this.$store.commit('setFilter', { price_range: [0, 15000] });
                    break;
                case 'district':
                    this.$store.commit('setSelectedDistricts', this.selected_districts.filter((i) => {
                        return i !== value;
                    }));
                    break;
                case 'bedrooms':
                    this.$store.commit('removeFromFilter', { bedrooms: value });
                    break;
                case 'bathrooms':
                    this.$store.commit('removeFromFilter', { bathrooms: value });
                    break;
                case 'amenity':
                    this.$store.commit('removeFromFilter', { amenities: value });
                    break;
                case 'rule':
                    this.$store.commit('removeFromFilter', { rules: value });
                    break;
                default:
                    break;
            }
            this.$store.commit('setPage', 1);
            this.$store.dispatch('replaceUrl');
            this.$store.dispatch('filterResults');
        },
    }
}
</script>

<style lang="scss">
.filter-breadcrumbs {
    width: 100%;

    .label {
        font-weight: 400;
        font-size: 12px;
        padding: 0.5em 0.7em;
        display: inline-block;
        margin-bottom: 0.5em;
    }

    i:hover {
        cursor: pointer;
    }
}
</style>
